import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { setores } from "@/constants/setores";

export function FilterSetor({ onChange, value }) {
  return (
    <Select
      value={value || ""}
      onValueChange={(val) => onChange(val === "all" ? "" : val)}
    >
      <SelectTrigger className="w-[200px]">
        <SelectValue placeholder="Filtrar setor" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Filtrar setor</SelectLabel>
          <SelectItem value="all">Todas setores</SelectItem>
          {setores.options.map((unidade) => (
            <SelectItem key={unidade.id} value={unidade.id}>
              {unidade.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
